module.exports = __webpack_public_path__ + "static/img/anxun08.a3c0c012.png";